import React from "react"
import { Helmet } from "react-helmet"

import OfferBase from "../../../components/offer"

const Offer = () => {
  return (
    <OfferBase offerTitle={'Wypełniacze'}>
      <Helmet title={"Wypełniacze - Dent&Beauty | Świdnica"} />
    </OfferBase>
  )
}

export default Offer
